export const CONFIGURATOR_STATE_VERSION = "4.1.0";

export const CHART_CONFIG_VERSION = "4.1.0";
